export const Input = ({ label, value, onChange, required, testid, type = "text" }) => (
  <label className="block text-xs uppercase tracking-widest text-[color:var(--text-muted)]">{label}
    <input data-testid={testid} type={type} required={required} value={value} onChange={e => onChange(e.target.value)}
      className="mt-1 w-full bg-[color:var(--bg-elev)] border border-[color:var(--border)] rounded-lg px-3 py-2 text-[color:var(--text)] focus:outline-none focus:border-[color:var(--accent)] transition-colors" />
  </label>
);

export const ChannelSelect = ({ channels, value, onChange, testid, label = "Chaîne cible", placeholder = "— choisir —" }) => (
  <label className="block text-xs uppercase tracking-widest text-[color:var(--text-muted)]">{label}
    <select data-testid={testid} required value={value} onChange={e => onChange(e.target.value)} className="mt-1 w-full bg-[color:var(--bg-elev)] border border-[color:var(--border)] rounded-lg px-3 py-2">
      <option value="">{placeholder}</option>
      {channels.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
    </select>
  </label>
);
